export default function showSnack(
  message,
  enqueueSnackbar,
  variant = 'success'
) {
  enqueueSnackbar(message, { variant });
}
